import state from '@bingads-webui-component-legacy/state/index';
import segmentTypes from '@bingads-webui-component-legacy/bingads-grid/shared/segmentationTypes';
import date from '@bingads-webui-component-legacy/humanize/date';

function isTimeRangeValid(segmentType) {
  const dateRange = state.get('$daterange') || { start: null, end: null };
  let startDate = null;
  let endDate = null;
  let goalSegmentStartDate = new Date('October 26, 2017 00:00:00'); //The first date that BI has segmentation data, offset by 1 day to ensure no timezone issues.
  let audienceSegmentStartDate = new Date('January 05, 2018 00:00:00'); //The first date that BI has segmentation data, offset by 1 day to ensure no timezone issues.

  if (dateRange) {
    startDate = dateRange.start;
    endDate = dateRange.end;
  }

  // If time range control didn't initialize successfully, we will just pass data directly to MT
  if (!startDate || !endDate) {
    return true;
  }

  let totalRange = date.diff(startDate, endDate, 'day');

  if (dateRange.compared && dateRange.compared.start && dateRange.compared.end) {
    totalRange += date.diff(dateRange.compared.start, dateRange.compared.end, 'day');
  }

  const oneYearAgo = date.todayNYearsAgo(endDate, 1);
  const threeYearsAgo = date.todayNYearsAgo(endDate, 3);
  const withinThreeYears = startDate >= threeYearsAgo;
  const moreThanOneYear = oneYearAgo >= startDate;

  switch (segmentType) {
  case segmentTypes.Day:
    return totalRange < 16;
  case segmentTypes.Week:
    return totalRange >= 7 && totalRange < 16 * 7;
  case segmentTypes.Month:
    return totalRange >= 30 && totalRange < 16 * 30;
  case segmentTypes.Quarter:
    return totalRange > 90 && withinThreeYears;
  case segmentTypes.Year:
    return moreThanOneYear && withinThreeYears;
  case segmentTypes.HourOfTheDay:
    return date.diff(dateRange.compared.start && dateRange.compared.start < startDate ? dateRange.compared.start : startDate, date.accountTimeZoneNow(), 'day') <= 180;
  case segmentTypes.GoalName:
  case segmentTypes.GoalType:
    return startDate >= goalSegmentStartDate;
  case segmentTypes.AudienceName:
  case segmentTypes.AudienceType:
    return startDate >= audienceSegmentStartDate;
  default :
    return true;
  }
}

export default {
  isTimeRangeValid,
};
